import { render, staticRenderFns } from "./KMenu.vue?vue&type=template&id=79884376&"
import script from "./KMenu.vue?vue&type=script&lang=js&"
export * from "./KMenu.vue?vue&type=script&lang=js&"
import style0 from "./KMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports